module.exports = __webpack_public_path__ + "static/media/min.b607c0f9.png";